$(function () {
    if ($('.detailBox').length > 0) {
        // Handles Collapsible content
        var coll = document.getElementsByClassName("collapsible");
        if (coll.length > 0) {
            var i;
            for (i = 0; i < coll.length; i++) {
                coll[i].addEventListener("click", function () {
                    this.classList.toggle("active");
                    var isExpanded = this.classList.contains("active");
                    this.setAttribute("aria-expanded", isExpanded);
                    var content = this.closest('.accordion-heading') ? this.closest('.accordion-heading').nextElementSibling : this.nextElementSibling;
                    if (content.style.maxHeight) {
                        content.style.maxHeight = null;
                    } else {
                        content.style.maxHeight = content.scrollHeight + "px";
                    }
                });
            }
        }
    }
});